import { useMutation } from '@tanstack/react-query';

import { WorkbookUpdateFormValues } from '../../../../../types';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { patchApplicationWorkbook } from '../../requests/patchApplicationWorkbook';

export const useUpdateApplicationWorkbook = (
  uuid: string,
  definitionName: string,
) => {
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: updateWorkbook, ...rest } = useMutation({
    mutationFn: (formValues: WorkbookUpdateFormValues) =>
      patchApplicationWorkbook(
        constructPatch,
        uuid,
        definitionName,
        formValues,
      ),
  });

  return { updateWorkbook, ...rest };
};
